import React from 'react';
import RetinaImage from 'react-retina-image';
import { Component } from 'ml-component-web';
import Analytics from '../shared/google-analytics/Analytics';

import logo from '../assets/logo_100.png';
import logo2x from '../assets/logo_100@2x.png';
import features1a from '../assets/features1a.png';
import features1a2x from '../assets/features1a@2x.png';
import features1b from '../assets/features1b.png';
import features1b2x from '../assets/features1b@2x.png';
import features2a from '../assets/features2a.png';
import features2a2x from '../assets/features2a@2x.png';
import features2b from '../assets/features2b.png';
import features2b2x from '../assets/features2b@2x.png';
import features3 from '../assets/features3.png';
import features32x from '../assets/features3@2x.png';
import apple from '../assets/apple_app_store.svg';
import apple2x from '../assets/apple_app_store@2x.svg';
import google from '../assets/google_app_store.png';
import google2x from '../assets/google_app_store@2x.png';
import './home.css';

export default class HomeHandlerView extends Component {

    downloadAndroid = () => {
        Analytics.sendEvent({
            ga: {
                category: 'Download',
                action: 'Android',
            },
        });
    }

    downloadApple = () => {
        Analytics.sendEvent({
            ga: {
                category: 'Download',
                action: 'Apple',
            },
        });
    }

    renderComponent() {
        return (
            <div>
                <section id="home">
                    <div className="home-jumbotron">
                        <div className="home-jumbotron-cover orange" data-color="orange" />
                        <div className="container">
                            <div className="home-jumbotron-header">
                                <RetinaImage className="logo" src={[logo, logo2x]} alt="MyBabyBio" />
                                <h1 className="logo-text">MyBabyBio</h1>
                            </div>
                            <div className="home-jumbotron-content">
                                <div className="motto-container">
                                    <h2 className="motto">The Online Baby Diary</h2>
                                    <h3 className="motto">Capture precious memories of your family and keep them safe forever</h3>
                                </div>
                                <div className="download">
                                    <a href="https://itunes.apple.com/gb/app/mybabybio-online-baby-diary/id1171889819?ls=1&mt=8" target="_blank" className="cta2 download" onClick={this.downloadApple} rel="noopener noreferrer">
                                        <RetinaImage alt="Download on the App Store" src={[apple, apple2x]} />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.mybabybio" target="_blank" className="cta2 download" onClick={this.downloadAndroid} rel="noopener noreferrer">
                                        <RetinaImage alt="Get it on Google Play" src={[google, google2x]} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="home-about" className="home-about container">
                    <div className="row" id="about_intro">
                        <div className="col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3" >
                            <h2>MyBabyBio is your child's past, present and future</h2>
                            <p>From birth through to the present day, MyBabyBio collects all the photos, videos and memories of your children so you can remember them forever.
                            </p>
                        </div>
                    </div>
                </section>
                <hr />
                <section id="home-features-1" className="home-feature-container">
                    <div className="container">
                        <div className="row"  >
                            <div className="col-sm-6 col-md-6  col-lg-6">
                                <RetinaImage className="home-feature-image-back img-responsive" src={[features1b, features1b2x]} />
                                <RetinaImage className="home-feature-image-front home-feature-image-pad img-responsive" src={[features1a, features1a2x]} />
                            </div>
                            <div className="home-feature-content col-sm-6 col-md-6 col-lg-6">
                                <h2>A beautiful online biography for your child</h2>
                                <div className="feature">
                                    <h4>Precious memories</h4>
                                    <p>Photos, videos, and milestones - MyBabyBio captures all the precious memories of your children and keeps them safe forever.</p>
                                </div>
                                <div className="feature">
                                    <h4>Effortlessly organised</h4>
                                    <p>MyBabyBio collates and organises all of your memories so you can easily revisit your favourites.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <hr />
                <section id="home-features-2" className="home-feature-container">
                    <div className="container">
                        <div className="row"  >
                            <div className="home-feature-content col-sm-6 col-md-6 col-lg-6">
                                <h2>Safe sharing with family and friends</h2>
                                <div className="feature">
                                    <h4>Privacy first</h4>
                                    <p>MyBabyBio is designed with your child's privacy in mind so you never need to worry about who sees your memories.</p>
                                </div>
                                <div className="feature">
                                    <h4>Simple but powerful</h4>
                                    <p>You control who can access memories of each of your children. Grandparents, family and friends - all can have different levels of access.</p>
                                </div>
                                <div className="feature">
                                    <h4>Secure</h4>
                                    <p>All your data is encrypted and transferred securely using 256 bit SSL - the highest standard of online encryption.</p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6  col-lg-6">
                                <RetinaImage className="home-feature-image-back img-responsive" src={[features2b, features2b2x]} />
                                <RetinaImage className="home-feature-image-front home-feature-image-pad img-responsive" src={[features2a, features2a2x]} />
                            </div>
                        </div>
                    </div>
                </section>
                <hr />
                <section id="home-features-3" className="home-more-features-container">
                    <div className="container">
                        <div className="home-more-features-intro row">
                            <div className="col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3" >
                                <h2>And lots, lots more...</h2>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="home-more-features-left col-sm-4 col-md-4 ol-lg-4">
                                <div className="feature">
                                    <h4>Never miss a moment</h4>
                                    <p>Notifications keep you up to date when you're away from your children.</p>
                                </div>
                                <div className="feature">
                                    <h4>Milestones</h4>
                                    <p>Record all your child's important developmental milestones.</p>
                                </div>
                            </div>
                            <div className="home-more-features-center col-sm-4 col-md-4 ol-lg-4">
                                <RetinaImage className="img-responsive" src={[features3, features32x]} />
                            </div>
                            <div className="home-more-features-right col-sm-4 col-md-4 ol-lg-4">
                                <div className="feature">
                                    <h4>Hi-res images</h4>
                                    <p>Full quality images safely and securely backed up to the cloud.</p>
                                </div>
                                <div className="feature">
                                    <h4>Photo printing (coming soon)</h4>
                                    <p>Easily turn your favourite photos into prints, photo books and more.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/handler/HomeHandlerView.js
 **/